import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonsModule, CardModule, RadioButtonModule } from 'axis-components';
import { InsuredMainService } from '../../../_services/pip/insured-main.service';
import { RequestService } from '../../../_services/request/request.service';
import { FormType, RequestProgressStep } from '../../../config/constants';
import { AnalyticsService } from '../../../_shared/analytics/analytics.service';
@Component({
  standalone: true,
  selector: 'app-pip-consent',
  templateUrl: './pip-consent.component.html',
  styleUrls: ['./pip-consent.component.scss'],
  imports: [ButtonsModule, CardModule, RadioButtonModule],
})
export class PipConsentComponent implements OnInit {
  constructor(
    private readonly insuredMainService: InsuredMainService,
    private router: Router,
    private requestService: RequestService,
    private analyticsService: AnalyticsService,
  ) {}

  disclosure: any;
  selectedOptionType: string = '';
  @Input() ctaData: any = {};
  @Input() formObj: any = {};
  @Output() selectionMade = new EventEmitter<string>();

  ngOnInit(): void {
    this.insuredMainService.getDisclosureData().subscribe((data) => {
      this.disclosure = data;
    });
    this.goTop();
  }
  goTop(): void {
    // reset the page when changing route
    window.scrollTo(0, 0);
  }

  onSelection(type: string): void {
    this.selectedOptionType = type;
    this.selectionMade.emit(type);
  }

  onContinue(): void {
    // Refresh request state so start logic uses the latest DB step.
    this.requestService.refreshRequestData(false).subscribe({
      next: () => this.handleContinueWithFreshStep(),
      // Fall back to cached state if the refresh call fails.
      error: () => this.handleContinueWithFreshStep(),
    });
  }

  private handleContinueWithFreshStep(): void {
    // Read current DB-backed step snapshot before moving the form ahead.
    const currentFormStep = this.requestService.getStepForFormType(
      FormType.PIP,
    );

    const isPipCompleted = this.requestService.isFormTypeAlreadyCompleted(
      FormType.PIP,
    );

    // If PIP is already completed, do not continue with consent routing.
    if (isPipCompleted) {
      return;
    }
    // Emit start only if this request has not started PIP yet.
    const shouldEmitFormStart =
      (!currentFormStep || currentFormStep.includes('Not Started')) &&
      !this.analyticsService.formStartPipSet;

    if (shouldEmitFormStart) {
      this.analyticsService.formStartPipSet = true;
    }

    this.requestService.updateRequestProgress(
      FormType.PIP,
      RequestProgressStep.DIGITAL_SIGNATURE_CONSENT,
      {},
    );

    // Get current origin like analytics directive
    const baseUrl = window.location.origin;

    if (this.selectedOptionType === 'rejected') {
      const targetRoute = '/insured/pip-non-digital';
      this.ctaData.ctaName = 'DigiSign:pip:consent:rejected:continue';
      this.ctaData.ctaUrl = `${baseUrl}${targetRoute}`;
      this.analyticsService.setAdobeDataLayerCTAEvent(this.ctaData);

      // Build formStart payload for the non-digital landing route.
      const originalPageName = 'DigiSign:pip:nonDigital';
      this.formObj.page = {
        ...this.formObj.page,
        pageName: originalPageName,
        URL: `${baseUrl}${targetRoute}`,
        fullURL: `${baseUrl}${targetRoute}`,
        previousURL: `${baseUrl}${window.location.pathname}`,
      };

      const currentStep = this.analyticsService.getStepFromUrl(
        `${baseUrl}${targetRoute}`,
        originalPageName,
      );
      this.formObj.event = 'formStart';
      // Emit start once even when the user begins through rejected consent path.
      if (shouldEmitFormStart) {
        this.analyticsService.setAdobeDataLayer(this.formObj, currentStep);
      }

      this.router.navigate([targetRoute], {
        queryParamsHandling: 'preserve',
      });
    } else {
      const targetRoute = '/insured/pip-selection';
      this.ctaData.ctaName = 'DigiSign:pip:consent:continue';
      this.ctaData.ctaUrl = `${baseUrl}${targetRoute}`;
      this.analyticsService.setAdobeDataLayerCTAEvent(this.ctaData);

      // Set page URL information in formObj for the target route
      // Preserve the original page name from formObj like analytics directive does
      const originalPageName = 'DigiSign:pip:selectionCoverages';

      this.formObj.page = {
        ...this.formObj.page,
        pageName: originalPageName,
        URL: `${baseUrl}${targetRoute}`,
        fullURL: `${baseUrl}${targetRoute}`,
        previousURL: `${baseUrl}${window.location.pathname}`,
      };

      const currentStep = this.analyticsService.getStepFromUrl(
        `${baseUrl}${targetRoute}`,
        originalPageName,
      );
      this.formObj.event = 'formStart';
      // Emit start once when the user starts from the selection path.
      if (shouldEmitFormStart) {
        this.analyticsService.setAdobeDataLayer(this.formObj, currentStep);
      }

      this.router.navigate([targetRoute], {
        queryParamsHandling: 'preserve',
      });
    }
  }
}
